<template>
    <div>
        <div class="mt-5" v-if="requestMade">
            <div class="vx-row">
                <div class="col-xs-12 col-md-6">
                    <div class="vx-row">
                        <div class="col-sm-12">
                            <p class="bold">Contacto con:</p>
                            <div class="vx-row">
                                <div :class="colClass" v-for="contact in contactOptions" :key="contact.value">
                                    <rg-radio class="w-full" groupName="contact" :label="contact.label" :value="contact.value" v-model="currentContact" />
                                </div>
                            </div>
                            <p class="bold">Tipo de actividad:</p>
                            <div class="vx-row">
                                <div class="vx-col md:w-1/4 sm:w-full w-full mb-3" v-for="activity in activityOptions" :key="activity.value">
                                    <rg-radio class="w-full" groupName="activity" :label="activity.label" :value="activity.value" v-model="currentActivity" />
                                </div>
                            </div>
                            <template v-if="resultsOptionsFiltered.length > 0">
                                <p class="text bold">Resultado:</p>
                                <div class="vx-row">
                                    <div :class="colClass" v-for="result in resultsOptionsFiltered" :key="result.value">
                                        <rg-radio class="w-full" groupName="result" :label="result.label" :value="result.value" v-model="currentResult" />
                                    </div>
                                </div>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-xs-12 col-md-6">
                    <div v-if="dataResponse.projects.length > 1">
                        <label class="bold">Deja marcados solo los proyectos a los cuales se les asignará el evento:</label>
                        <div class="centerx">
                            <vs-col v-for="(project, index) in dataResponse.projects" :key="index">
                                <vs-checkbox v-model="projectsSelected" color="success" class="mb-2" :vs-value="project.project_id" >{{ project.alias }} (PID: {{ project.project_id }})</vs-checkbox>
                            </vs-col>
                        </div>
                    </div>
                    <label class="bold">Vista previa del evento de cobranza:</label>
                    <vx-textarea v-model="eventPreview" height="200px"/>
                    <div class="flex flex-wrap">
                        <vs-button :disabled="projectsSelected.length == 0 || eventPreview == ''" color="success" @click="sendEvent()">Guardar</vs-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import RgRadio from "@components/misc/RgRadio.vue";

    export default {
        name: "AdministrativeCashingProjectEvents",
        props:['clientId'],
        components: {
            RgRadio
        },
        async mounted(){
            await this.getEvents();
        },
        data(){
            return {
                cashingEventTypeManual: 'cashing_manual',
                colClass: "vx-col md:w-1/3 sm:w-full w-full mb-3",
                currentContact: null,
                contactOptions: [
                    {"value": 1, "label": "Titular"},
                    {"value": 2, "label": "Obligado solidario"},
                    {"value": 3, "label": "Referencia"}
                ],
                currentActivity: null,
                activityOptions: [
                    {"value": 1, "label": "Whatsapp"},
                    {"value": 2, "label": "Llamada telefónica"},
                    {"value": 3, "label": "Correo electrónico"},
                    {"value": 4, "label": "SMS"},
                ],
                currentResult: null,
                projectsSelected:[],
                selectedProject: 0,
                dataResponse: {
                    events:[],
                    projects:[],
                    cashingEvents:[]
                },
                requestMade: false,
                eventPreview: ""
            }
        },
        watch: {
            currentActivity: function () {
                this.currentResult = null;
            },
            currentResult: function () {
                let preview = "";
                if (!this.currentResult) {
                    this.eventPreview = preview;
                }
                let contact = this.contactOptions.find(x => x.value == this.currentContact);
                let activity = this.activityOptions.find(x => x.value == this.currentActivity);
                switch (this.currentResult) {
                    case "1":
                        preview = `${activity.label} a ${contact.label}. Se hace promesa de pago.`;
                        break;
                    case "2":
                        preview = `${contact.label} recibió ${activity.label}, deja en visto.`;
                        break;
                    case "3":
                        preview = `${activity.label} a ${contact.label}. Negativa de pago.`;
                        break;
                    case "4":
                        preview = `${contact.label} no contesta llamada. Continúa gestión.`;
                        break;
                    case "5":
                        preview = `${contact.label} no contesta llamada. Se dejó mensaje de voz.`;
                        break;
                    case "6":
                        preview = `${activity.label} a ${contact.label}. Continúa gestión de cobranza.`;
                        break;
                    case "7":
                        preview = `Se envió mensaje vía ${activity.label} a ${contact.label} indicando atraso.`;
                        break;
                    case "8":
                        preview = `Se envió mensaje vía ${activity.label} a ${contact.label} enviando carta para visita.`;
                        break;
                    default:
                        break;
                }
                this.eventPreview = preview;
            }
        },
        computed:{
            resultsOptionsFiltered () {
                let results = [];
                if (!this.currentActivity || !this.currentContact) {
                    return results;
                }
                switch (this.currentActivity) {
                    case "1":
                        results= [
                            {"value": 1, "label": "Se logra contacto. Se hace promesa de pago."},
                            {"value": 2, "label": "Recibió mensaje, deja en visto."},
                            {"value": 3, "label": "Se logra contacto. Negativa de pago."},
                            {"value": 6, "label": "Se logra contacto. Continúa gestión de cobranza."}
                        ];
                        break;
                    case "2":
                        results= [
                            {"value": 1, "label": "Se logra contacto. Se hace promesa de pago."},
                            {"value": 3, "label": "Se logra contacto. Negativa de pago."},
                            {"value": 4, "label": "No contesta llamada. Continúa gestión."},
                            {"value": 5, "label": "No contesta llamada. Se dejó mensaje de voz."},
                            {"value": 6, "label": "Se logra contacto. Continúa gestión de cobranza."}
                        ];
                        break;
                    case "3":
                        results= [
                            {"value": 7, "label": "Se envió mensaje indicando atraso."},
                            {"value": 8, "label": "Carta para visita"}
                        ];
                        break;
                    case "4":
                        results= [
                            {"value": 1, "label": "Se logra contacto. Se hace promesa de pago."},
                            {"value": 3, "label": "Se logra contacto. Negativa de pago."},
                            {"value": 6, "label": "Se logra contacto. Continúa gestión de cobranza."}
                        ];
                        break;
                    default:
                        break;
                }
                return results;
            }
        },
        methods: {
            async getEvents(){
                this.resetValues();
                this.showLoading(true);
                this.requestMade = false;
                await axios.post('/api/cobranza/projectCashingEventsList',{ client_id: this.clientId }).then(response => {
                    this.dataResponse = response.data;
                    this.setProjectsForCheckBoxes();
                    this.selectedProject = this.dataResponse.projects[0].project_id;
                    this.requestMade = true;
                }).catch(error => {
                    this.requestMade = false;
                    if(error.response.data.message !== undefined){
                        this.errorNotif("Aviso", error.response.data.message, 4000);
                    }else{
                        this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                    }
                });
                this.requestMade = true;
                this.showLoading(false);
            },
            async sendEvent(){
                if(this.eventPreview){
                    this.showLoading(true);
                    let cashingEventTypeCalculated = this.cashingEventTypeManual;
                    if (this.currentActivity && this.currentContact && this.currentResult) {
                        cashingEventTypeCalculated = 'cashing_contact_attempt'
                    }
                    await axios.post('/api/cobranza/postProjectCashingEvent', {
                        project_ids: this.projectsSelected,
                        event: this.eventPreview,
                        cashing_event_type: cashingEventTypeCalculated,
                        action: "save"
                    }).then(response => {
                        this.resetValues();
                        this.dataResponse = response.data;
                        this.setProjectsForCheckBoxes();
                        this.successNotif("Aviso", 'Evento guardado exitosamente', 4000);
                    }).catch(error => {
                        this.errorNotif("Aviso", 'Ha ocurrido un error intente mas tarde.', 4000);
                    })
                    this.showLoading(false);
                }
            },
            setProjectsForCheckBoxes(){
                this.projectsSelected = [];
                Object.keys(this.dataResponse.projects).forEach(key => {
                    const project = this.dataResponse.projects[key];
                    this.projectsSelected.push(project.project_id);  
                })
            },
            resetValues(){
                this.currentContact = null;
                this.currentActivity = null;
                this.eventPreview = "";
            }
        }
    }
</script>